// 日期格式化
import { getLiveJump } from '@/api/bus-course'

export function parseTime (time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  if (time.indexOf('01-01-01') > -1) {
    return '-'
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  return format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

// 打开直播间
export function goOpenLive(item, backUrl = '') {
  return new Promise((rel, reject) => {
    if (item.isClickDisabled) return;
    item.isClickDisabled = true;
    getLiveJump(item).then((res) => {
      doOpenLiveUrl(res.data, backUrl, item)
    }).catch(e => {
      item.isClickDisabled = false;
      reject(e)
    })
  });
}

// 打开直播链接
export function doOpenLiveUrl(url, backUrl = '', item = {}) {
  const debugJs = location.protocol + '//' + location.host + '/live/preview/index.js';
  const debugCss = location.protocol + '//' + location.host + '/live/preview/index.css';
  const debugUrl = process.env.NODE_ENV === 'development' ? `&debugjs=${debugJs}&debugcss=${debugCss}` : ''
  const echoline_room_id = item.id || ''
  // 是否常显头部
  // const showHeader = item.isTeacher ? 1 : 0
  const showHeader = Number(item.autoHideBar === 1) ? 1 : 0
  // 是否禁用进出消息
  const disabledJoinMsg = 1
  if (!backUrl) {
    const link = document.createElement('a');
    link.href = url + `&echoline_room_id=${echoline_room_id}&show-header=${showHeader}&disabled-join-msg=${disabledJoinMsg}${debugUrl}`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    location.href = url + `&echoline_room_id=${echoline_room_id}&show-header=${showHeader}&disabled-join-msg=${disabledJoinMsg}&back_url=` + encodeURIComponent(backUrl) + debugUrl;
  }
}

// 检测是否在uniapp的webview环境中
export function isUniAppWebView() {
  const isUniApp = typeof window !== 'undefined' &&
    (window.plus ||
     window.uni ||
     window.webkit && window.webkit.messageHandlers ||
     navigator.userAgent.indexOf('uni-app') > -1 ||
     navigator.userAgent.indexOf('Html5Plus') > -1 ||
     navigator.userAgent.indexOf('AlipayClient') > -1 ||
     /miniProgram/i.test(navigator.userAgent) ||
     /toutiaomicroapp/i.test(navigator.userAgent) ||
     /swan/i.test(navigator.userAgent) ||
     /quickapp/i.test(navigator.userAgent));
  return new Promise((resolve) => {
    if (isUniApp) {
      isUniApp.getEnv((env) => {
        if (env.h5) {
          console.log('当前环境为：h5');
          resolve(false);
        } else if (env.pc) {
          console.log('当前环境为：pc');
          resolve(false);
        } else {
          resolve(true);
        }
      });
    } else {
      resolve(false);
    }
  })
}

// 等待uni SDK加载完成
export function waitForUniSDK() {
  return new Promise((resolve) => {
    if (window.uni) {
      resolve(window.uni);
      return;
    }

    // 监听UniAppJSBridgeReady事件
    document.addEventListener('UniAppJSBridgeReady', function() {
      resolve(window.uni);
    });

    // 设置超时，避免无限等待
    setTimeout(() => {
      resolve(window.uni || null);
    }, 1000);
  });
}

// 异步跳转到uniapp首页
export async function navigateToUniAppHomeAsync(uni, callbackUrl = '') {
  if (!uni) {
    console.log("uni SDK未加载完成")
    return false;
  }
  callbackUrl = callbackUrl === 'undefined' ? '' : callbackUrl
  try {
    console.log("准备执行跳转")
    if (uni.webView) {
      console.log(callbackUrl || '/pages/tabBar/live')
      console.log("开始执行", "uni.webView")
      uni.webView.reLaunch({
        url: callbackUrl || '/pages/tabBar/live'
      });
    } else {
      uni.reLaunch({
        url: callbackUrl || '/pages/tabBar/live'
      });
    }
  } catch (error) {
    console.log('uni API调用失败:', JSON.stringify(error));
    return false;
  }
}
